

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {Prop, VModel} from "vue-property-decorator";
import {IWebhoook} from "@/model/Webhook/webhoookInterfaces";

const webhookModule = namespace("webhookModule");


enum allowedWebhookActions {
  orders = 'orders/webhook',
  users = 'users/webhook'
}
@Component({})
export default class WebhookDetailDialog extends Vue {
  @VModel()
  protected show!: boolean;
  @Prop()
  private loading!: boolean;
  @webhookModule.Action('sendSampleCall')
  private sendSampleCall!: (id: number) => any;

  @webhookModule.Getter('webhook')
  private webhook!: IWebhoook|null;

  protected actionList: string[] = [
    allowedWebhookActions.orders,
    allowedWebhookActions.users
  ]
  protected submitting: boolean = false;
  private subscribes: IOnOffHandlers = {};

  protected created() {
    this.subscribes = this.$ons({
      'backend.call.OK.webhookSampleCallSent': this.onSampleCallOK,
      'backend.call.KO.webhookSampleCallSent': this.onSampleCallKO,
    });
  }

  protected beforeDestroy() {
    this.$offs(this.$ons);
  }

  protected onClose() {
    this.show = false;
  }
  protected onSendSampleCall() {
    if (!this.webhook) {
      return;
    }
    this.submitting = true;
    this.sendSampleCall(this.webhook.id);
  }
  protected onSampleCallOK() {
    this.$uiBus.emit('success', 'OK');
    this.submitting = false;
  }
  protected onSampleCallKO() {
    this.$uiBus.emit('alert', 'KO');
    this.submitting = false;
  }

}
